export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8055.ad0d972b.jpg";